import { createContext } from 'react'

export const DocFlowContext = createContext()
